












import { computed, defineComponent, onMounted, onUnmounted, ref } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useNotifications from "@/hooks/useNotifications";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import PageNotificationsView from "./components/PageNotificationsView";
import { NotificationsKey, notificationsTypes } from "./config";

export default defineComponent({
  name: "PageNotifications",
  components: { PageNotificationsView },
  setup() {
    const { isAnyCreator } = useAuthUser();
    const { loading, enableScroll, notifications, getNotifications, getNextData, markRead } = useNotifications();
    const activeFilter = ref<NotificationsKey>("all");
    const lastNotification = computed(() => {
      if (notifications.value.length === 0) return;
      return notifications.value.reduce(
        (notification_1, notification_2) =>
          Number(notification_2.id) > Number(notification_1.id) ? notification_2 : notification_1,
        notifications.value[0]
      );
    });

    const getPageData = async (types?: string[]) => {
      try {
        loading.value = true;
        await getNotifications({ types });
      } finally {
        loading.value = false;
      }
    };

    const updatePageData = async (notification: Notification) => {
      if (loading.value) return;
      await getPageData(notificationsTypes.value[activeFilter.value]);
      await markRead(notification);
    };

    const handleFilterNotification = (type: NotificationsKey) => {
      if (activeFilter.value !== type) {
        activeFilter.value = type;
        getPageData(notificationsTypes.value[activeFilter.value]);
      }
    };

    const handleNextPage = (cb?: () => void) => {
      getNextData(cb, { types: notificationsTypes.value[activeFilter.value] });
    };

    onMounted(async () => {
      await getPageData(notificationsTypes.value[activeFilter.value]);
      if (lastNotification.value) await markRead(lastNotification.value);
      emitter.on<any>(EVENTS.NOTIFICATIONS_NEW_NOTIFICATION, updatePageData);
    });

    onUnmounted(() => {
      emitter.off<any>(EVENTS.NOTIFICATIONS_NEW_NOTIFICATION, updatePageData);
    });

    return {
      loading,
      enableScroll,
      isAnyCreator,
      activeFilter,
      notifications,
      notificationsTypes,
      getNextData,
      handleFilterNotification,
      handleNextPage,
    };
  },
});
